import { render, staticRenderFns } from "./textfield-screen.vue?vue&type=template&id=4d638055&scoped=true&"
import script from "./textfield-screen.vue?vue&type=script&lang=js&"
export * from "./textfield-screen.vue?vue&type=script&lang=js&"
import style0 from "./textfield-screen.vue?vue&type=style&index=0&id=4d638055&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d638055",
  null
  
)

export default component.exports